class SlideReviews extends HTMLElement {
  constructor() {
    super();

    this.slide = this;
    this.flkty = new Flickity(this.slide, {
      pageDots: false,
      adaptiveHeight: false,
      prevNextButtons: true,
      imagesLoaded: true,
      wrapAround: true,
      watchCSS: true
    });
  }
}

customElements.define("slide-reviews", SlideReviews);